// Configuração do ambiente **due-dev** — emuladores locais, apenas.
//
// Espelha `modules/due-empresa/app/src/config/dev/firebaseConfig.js` (commit
// 11ec7d16). `due-dev` NÃO é um projeto Firebase real — existe só para o app
// ter um projectId estável ao falar com os emuladores. Nenhuma destas
// credenciais alcança serviço real: os `connectXEmulator` em
// `../firebaseConfig.js` redirecionam tudo para 127.0.0.1 antes de qualquer
// chamada de rede.
export const DEV_CONFIG = {
  apiKey: "due-dev-emulador-local",
  authDomain: "due-dev.firebaseapp.com",
  projectId: "due-dev",
  storageBucket: "due-dev.appspot.com",
  messagingSenderId: "000000000000",
  appId: "1:000000000000:web:duedevemuladorlocal",
};

export default DEV_CONFIG;
